import {
  createContext,
  useContext,
  useState,
  ReactNode,
  FC,
} from "react";

import {
  IContextParcelas,
  IFilesUploadImportInstallments,
  IListUploadInstallments,
} from "./ParcelasTypes";
import { valuesDefaultUploadImportInstallments } from "./valuesDefaultInputsParcelas/ValueDefaultInputParcelas";

const ParcelasContext = createContext({} as IContextParcelas);

export const ParcelasContextProvider: FC<{ children: ReactNode }> = ({
  children,
}) => {
  const [filesUploadImportInstallments, setFilesUploadImportInstallments] = useState<IFilesUploadImportInstallments>(valuesDefaultUploadImportInstallments);
  const [listUploadInstallments, setListUploadInstallments] = useState<IListUploadInstallments>({ data: [] });

  return (
    <ParcelasContext.Provider
      value={{
        filesUploadImportInstallments,
        setFilesUploadImportInstallments,
        listUploadInstallments,
        setListUploadInstallments,
      }}
    >
      {children}
    </ParcelasContext.Provider>
  );
};

export const useContextParcelas = (): IContextParcelas => useContext(ParcelasContext);
